import React from "react";
import { getMsgReplyLabel } from "../messages/utils";
import { CSSTransition } from "react-transition-group";
import { SmileOutlined } from "@ant-design/icons";
import EmojiPicker from "./EmojiPicker";

export default function ChatInputBar({
  replyMsg,
  onCancelReply,
  showEmoji,
  onToggleEmoji,
  inputRef,
  inputValue,
  onInputChange,
  onFocus,
  onBlur,
  onKeyDown,
  onMediaSelect,
  onSend,
  getEmojiConfig,
  insertAtCursor,
  isMuted,
}) {
  return (
    <div className={`imc-input-area${isMuted ? " imc-input-area-muted" : ""}`}>
      {/* 回复条 */}
      {replyMsg && !isMuted && (
        <div className="imc-reply-strip">
          <span className="imc-reply-strip-text">
            回复 {replyMsg.fromNick}：{getMsgReplyLabel(replyMsg)}
          </span>
          <span className="imc-reply-strip-close" onClick={onCancelReply}>✕</span>
        </div>
      )}

      <div className="imc-input-row">
        {/* Emoji 按钮 */}
        <div className={`imc-input-icon${isMuted ? " imc-input-icon-disabled" : ""}`} onClick={isMuted ? undefined : onToggleEmoji}>
          <SmileOutlined style={{ fontSize: 22, color: isMuted ? "#ccc" : "#666" }} />
        </div>

        {/* 文本输入框 */}
        <div className="imc-textarea-wrap">
          <textarea
            ref={inputRef}
            className="imc-textarea"
            placeholder={isMuted ? "您已被管理员禁言" : "和大家说点什么吧"}
            value={isMuted ? "" : inputValue}
            onChange={isMuted ? undefined : onInputChange}
            onFocus={isMuted ? undefined : onFocus}
            onBlur={isMuted ? undefined : onBlur}
            onKeyDown={isMuted ? undefined : onKeyDown}
            disabled={isMuted}
            rows={1}
          />
        </div>

        {/* 图片/视频上传 */}
        <label className={`imc-input-icon imc-input-img-label${isMuted ? " imc-input-icon-disabled" : ""}`}>
          <input
            type="file"
            accept="image/*,video/*"
            style={{ display: "none" }}
            onChange={isMuted ? undefined : onMediaSelect}
            disabled={isMuted}
          />
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={isMuted ? "#ccc" : "#666"} strokeWidth="1.8">
            <rect x="3" y="3" width="18" height="18" rx="2" />
            <circle cx="8.5" cy="8.5" r="1.5" />
            <polyline points="21,15 16,10 5,21" />
          </svg>
        </label>

        {/* 禁言时不显示发送按钮 */}
        {!isMuted && inputValue.trim() && (
          <div className="imc-send-btn" onClick={onSend}>
            发送
          </div>
        )}
      </div>

      {/* 禁言时不展示 Emoji 面板 */}
      {!isMuted && (
        <CSSTransition in={showEmoji} timeout={250} classNames="imc-emoji" unmountOnExit>
          <EmojiPicker getEmojiConfig={getEmojiConfig} onSelect={insertAtCursor} />
        </CSSTransition>
      )}
    </div>
  );
}
